import { render } from "./home-sec8.vue?vue&type=template&id=1bd5b9e5"
import script from "./home-sec8.vue?vue&type=script&lang=js"
export * from "./home-sec8.vue?vue&type=script&lang=js"

import "./home-sec8.vue?vue&type=style&index=0&id=1bd5b9e5&scopped=true&lang=css"

import exportComponent from "C:\\Users\\jomon\\OneDrive\\Desktop\\algorithma-website-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__